import { environment } from '../../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('TeamMemberContactService', TeamMemberContactService);

  TeamMemberContactService.$inject = [
    'RestResource',
    '$translate',
    '$filter',
    'UtilService',
    'WindowModalService',
  ];

  function TeamMemberContactService(
    RestResource,
    $translate,
    $filter,
    UtilService,
    WindowModalService
  ) {
    const utils = new UtilService(this);

    $translate = $filter('translate');

    const apiUrl = environment.apiEndpoint + 'team_members';

    var service = {
      openTeamMemberContactModal: openTeamMemberContactModal,
      saveTeamMemberContact: saveTeamMemberContact,
      changeTeamMemberContactStatus: changeTeamMemberContactStatus,
      changeTeamMemberContactDefault: changeTeamMemberContactDefault,
      deleteTeamMemberContact: deleteTeamMemberContact,
    };

    return service;

    function openTeamMemberContactModal(teamMemberContact, teamMember, mode, successCallback) {
      let templateUrl =
        './app/ajs/team-members/team-member-contacts/modals/team-member-contact-detail-modal.html';

      let originalItem = angular.copy(teamMemberContact);
      originalItem.team_member_id = teamMember.id;

      let modalParams = {
        title: teamMemberContact.id ? 'CONTACT_DETAILS' : 'NEW_CONTACT',
        item: originalItem,
        mode: mode,
        closeOnSave: true,
      };

      let confirmCallback = function (response) {
        if (teamMemberContact.id) {
          teamMemberContact.name = response.name;
          teamMemberContact.last_name = response.last_name;
          teamMemberContact.relation = response.relation;
          teamMemberContact.email = response.email;
          teamMemberContact.phone_number = response.phone_number;
          teamMemberContact.mobile_number = response.mobile_number;

          return utils.itemListChanged(response.id);
        }

        return successCallback(response);
      };

      WindowModalService.open(templateUrl, modalParams, confirmCallback);
    }

    function saveTeamMemberContact(teamMemberContact, teamMemberId) {
      let url = `${apiUrl}/${teamMemberId}/team_member_contacts`;

      let method = teamMemberContact.id ? 'put' : 'post';
      url = teamMemberContact.id ? `${url}/${teamMemberContact.id}` : url;

      function success(response) {
        let msg = teamMemberContact.id ? 'CONTACT_MODIFIED' : 'CONTACT_ADDED';
        utils._successMsg($translate(msg));

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(
        method,
        url,
        { team_member_contact: teamMemberContact },
        success,
        failure
      );
    }

    function changeTeamMemberContactStatus(teamMemberContact, teamMemberId) {
      let url = `${apiUrl}/${teamMemberId}/team_member_contacts/${teamMemberContact.id}`;

      const params = { title: null, successMsg: null };

      if (teamMemberContact.status === 'active') {
        params.title = 'DEACTIVATE_CONTACT';
        params.successMsg = 'CONTACT_MODIFIED';
      }

      utils.changeItemStatus(url, teamMemberContact, params);
    }

    function changeTeamMemberContactDefault(teamMemberContact, successCallback) {
      let url = `${apiUrl}/${teamMemberContact.team_member_id}/team_member_contacts${teamMemberContact.id}`;

      const params = {
        team_member_contact: {
          is_default: true,
        },
        set_default: true,
      };

      function success() {
        utils._successMsg($translate('DEFAULT_CONTACT_CHANGED'));

        return successCallback();
      }
      function failure() {}

      return RestResource.request('put', url, params, success, failure);
    }

    function deleteTeamMemberContact(teamMemberContact, teamMemberId, successCallback, index) {
      const params = {
        title: 'DELETE_CONTACT',
        reason: 'DELETE_ITEM_REASON',
        successMsg: 'CONTACT_DELETED',
      };

      var url = `${apiUrl}/${teamMemberId}/team_member_contacts/${teamMemberContact.id}`;
      utils.deleteItem(url, successCallback, params, index);
    }
  }
})();
